import React, { useMemo, useState, useEffect } from "react";
import Sidebar from "../../../components/Sidebar";
import AdNav from "../../../components/AdNav";
// import "../../../components/ad.css"
import "../../../components/ad.css";
import { setLoading } from "../../../slice/authSlice";
import { useSelector, useDispatch } from "react-redux";
import {
  useInitialdataGetQuery,
  useUploadExcelMutation,
  useWithdrawUpdateMutation,
} from "../../../slice/authApiSlice";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import moment from "moment";
import { FixedSizeList as List } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";
import { Box } from "@mui/material";

const columns = [
  { id: "name", label: "Name", minWidth: 170 },
  { id: "code", label: "College Type", minWidth: 200 },
  {
    id: "population",
    label: "City",
    // minWidth: 170,
    align: "left",
  },
  {
    id: "size",
    label: "State",
    // minWidth: 170,
    align: "left",
  },
  {
    id: "density",
    label: "Ranking",
    // minWidth: 170,
    align: "left",
  },
];

const columnsJob = [
  { id: "name", label: "Title", minWidth: 170 },
  { id: "code", label: "Exprience required", minWidth: 200 },
  {
    id: "population",
    label: "Location",
    // minWidth: 170,
    align: "left",
  },
  {
    id: "size",
    label: "Number of Position",
    // minWidth: 170,
    align: "left",
  },
  {
    id: "density",
    label: "Total applied",
    align: "left",
  },
];

const columnsCalls = [
  { id: "name", label: "User" },
  { id: "code", label: "Counsellor" },
  {
    id: "population",
    label: "Duration",
    // minWidth: 170,
    align: "left",
  },
  {
    id: "size",
    label: "Room_Id",
    // minWidth: 170,
    align: "left",
  },
  {
    id: "density",
    label: "Status",
    align: "left",
  },
];

const columnsWithdraw = [
  { id: "name", label: "Name" },
  { id: "code", label: "UPI ID" },
  {
    id: "population",
    label: "Amount",
    // minWidth: 170,
    align: "left",
  },
  {
    id: "size",
    label: "Req_Id",
    // minWidth: 170,
    align: "left",
  },
  {
    id: "density",
    label: "Status",
    align: "left",
  },
];

const columnsPayment = [
  { id: "name", label: "Name" },
  { id: "code", label: "Amount" },
  {
    id: "population",
    label: "Order Id",
    // minWidth: 170,
    align: "left",
  },
  {
    id: "size",
    label: "Date",
    // minWidth: 170,
    align: "left",
  },
  {
    id: "density",
    label: "Status",
    align: "left",
  },
];

const columnsVideos = [
  { id: "name", label: "User" },
  { id: "code", label: "Counsellor" },
  {
    id: "population",
    label: "Slot",
    // minWidth: 170,
    align: "left",
  },
  {
    id: "size",
    label: "Date",
    // minWidth: 170,
    align: "left",
  },
  {
    id: "density",
    label: "Status",
    align: "left",
  },
];

function createData(name, code, population, size) {
  const density = population / size;
  return { name, code, population, size, density };
}

export default function RecruiterFeeds() {
  const [collapsed, setCollapsed] = useState(true);
  const user = useSelector((state) => state.auth.userInfo);
  const dispatch = useDispatch();
  const { data, isLoading } = useInitialdataGetQuery();
  const [withdrawUpdate] = useWithdrawUpdateMutation();
  const [file, setFile] = useState(null);
  const [searchRoomId, setSearchRoomId] = useState("");
  const [slot, setSlot] = useState("");
  const [oreder, setOrder] = useState("");
  const [request, setRequest] = useState("");
  const [cname, setCname] = useState("");
  const [title, setTitle] = useState("");
  const [uploadExcel, { isLoading: upLoading }] = useUploadExcelMutation();
  //  console.log(data);

  useEffect(() => {
    dispatch(setLoading(isLoading));

    if (upLoading) dispatch(setLoading(true));

    return () => dispatch(setLoading(false));
  }, [isLoading, upLoading, dispatch]);

  const handleAccept = async (id) => {
    await withdrawUpdate(id);
  };

  const filteredCallHistory = data?.calls?.filter((call) =>
    call.roomId.toLowerCase().includes(searchRoomId.toLowerCase()),
  );

  const filteredSessionHistory = data?.videos?.filter((call) =>
    call.time.toLowerCase().includes(slot.toLowerCase()),
  );

  const filteredWithdrawHistory = data?.withdraw?.filter((call) =>
    call.reqId.toLowerCase().includes(request.toLowerCase()),
  );

  const filteredPaymentHistory = data?.payments?.filter((call) =>
    call.orderId.toLowerCase().includes(oreder.toLowerCase()),
  );

  const filteredCollegeHistory = useMemo(() => {
    return (data?.colleges ?? []).filter((call) =>
      call?.name?.toLowerCase().includes(cname.toLowerCase()),
    );
  }, [data?.colleges, cname]);

  const filteredJobsHistory = data?.jobs?.filter((call) =>
    call.title.toLowerCase().includes(title.toLowerCase()),
  );

  const handleUpload = async () => {
    if (!file) return alert("Please choose a file");

    const formData = new FormData();
    formData.append("excel", file);

    try {
      await uploadExcel(formData);
      alert("Upload successful");
      setFile(null);
    } catch (error) {
      console.error(error);
      alert("Upload failed");
    }
  };

  return (
    <div style={{ display: "flex" }}>
      <div style={{ flex: 1 }}>
        <div className="mainPage">
          {!isLoading && (
            <>
              <div className="upperCard">
                <div>
                  <h2>
                    Hi {user?.firstName} {user?.lastName}, Welcome back
                  </h2>
                  <p>
                    Managing users, counsellors, coins, payments, colleges and
                    jobs
                  </p>
                </div>
                <div className="coin">
                  <h2>Coins : Unlimited</h2>
                </div>
              </div>

              <div className="cardSec">
                <div className="userCard">
                  <div className="userInner">
                    <h2>Total users</h2>
                    <h5>{data?.user?.length}</h5>
                  </div>
                  <div className="userInner">
                    <h6>Today added users</h6>
                    <p>0</p>
                  </div>
                </div>
                <div className="userCard">
                  <div className="userInner">
                    <h2>Total counsellors</h2>
                    <h5>{data?.counsellors?.length}</h5>
                  </div>
                  <div className="userInner">
                    <h6>Today added counsellors</h6>
                    <p>0</p>
                  </div>
                </div>
                <div className="userCard">
                  <div className="userInner">
                    <h2>Total jobs</h2>
                    <h5>{data?.jobs?.length}</h5>
                  </div>
                  <div className="userInner">
                    <h6>Today added jobs</h6>
                    <p>0</p>
                  </div>
                </div>
                <div className="userCard">
                  <div className="userInner">
                    <h2>Total Colleges</h2>
                    <h5>{data?.colleges?.length}</h5>
                  </div>
                  <div className="userInner">
                    <h6>Today applied jobs</h6>
                    <p>0</p>
                  </div>
                </div>
              </div>

              <div className="cardSec">
                <div className="userCard">
                  <div className="userInner">
                    <h2>Total transaction</h2>
                    <h5>{data?.payments?.length}</h5>
                  </div>
                  <div className="userInner">
                    <h6>Today transaction</h6>
                    <p>0</p>
                  </div>
                </div>
                <div className="userCard">
                  <div className="userInner">
                    <h2>Total calls</h2>
                    <h5>{data?.calls?.length}</h5>
                  </div>
                  <div className="userInner">
                    <h6>Today calls</h6>
                    <p>0</p>
                  </div>
                </div>
                <div className="userCard">
                  <div className="userInner">
                    <h2>Total sessions</h2>
                    <h5>{data?.videos?.length}</h5>
                  </div>
                  <div className="userInner">
                    <h6>Today sessions</h6>
                    <p>0</p>
                  </div>
                </div>
                <div className="userCard">
                  <div className="userInner">
                    <h2>Total chats</h2>
                    <h5>{data?.bookings?.length}</h5>
                  </div>
                  <div className="userInner">
                    <h6>Today chats</h6>
                    <p>0</p>
                  </div>
                </div>
              </div>

              <div className="collegeAddSec">
                {/* Colleges Section */}
                <div className="college">
                  <div className="collegeInner">
                    <div className="collegeDesc">
                      <h2>Colleges</h2>
                    </div>

                    <div className="collegeDesc">
                      <input
                        type="text"
                        placeholder="Search by name"
                        value={cname}
                        onChange={(e) => setCname(e.target.value)}
                      />

                      <input
                        type="file"
                        id="fileUpload"
                        className="hiddenFileInput"
                        accept=".xlsx, .xls"
                        onChange={(e) => setFile(e.target.files[0])}
                      />
                      <label htmlFor="fileUpload" className="customFileLabel">
                        Choose File
                      </label>

                      <button onClick={handleUpload}>
                        {upLoading ? "Uploading..." : "Add"}
                      </button>
                    </div>
                  </div>
                  {/* Virtualized Colleges Table */};
                  <TableContainer
                    sx={{ height: 400, borderRadius: 2, overflow: "hidden" }}
                  >
                    <Table
                      stickyHeader
                      aria-label="sticky table"
                      sx={{ tableLayout: "fixed" }}
                    >
                      <TableHead>
                        <TableRow>
                          {/* {columns.map((column) => (
          <TableCell
            key={column.id}
            align={column.align}
          
          >
            {column.label}
          </TableCell>
        ))} */}
                          {columns.map((column) => (
                            <TableCell
                              key={column.id}
                              align={column.align}
                              style={{ minWidth: column.minWidth }}
                            >
                              {column.label}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                    </Table>

                    {/* Wrap virtualization inside div, not <TableBody> */}
                    <Box sx={{ height: 450, overflow: "auto" }}>
                      <AutoSizer>
                        {({ height, width }) => (
                          <List
                            height={height}
                            itemCount={filteredCollegeHistory?.length || 0}
                            itemSize={150}
                            width={width}
                            overscanCount={5}
                          >
                            {({ index, style }) => {
                              const college = filteredCollegeHistory?.[index];
                              if (!college) return null;

                              return (
                                <Box
                                  key={college._id || index}
                                  style={{
                                    ...style,
                                    display: "flex",
                                    borderBottom: "1px solid #e0e0e0",
                                    backgroundColor:
                                      index % 2 === 0 ? "#fafafa" : "#fff",
                                    alignItems: "center",
                                  }}
                                >
                                  <Box sx={{ flex: 1, px: 2 }}>
                                    {college?.name || "—"}
                                  </Box>
                                  <Box sx={{ flex: 1, px: 2 }}>
                                    {college?.cType?.name || "—"}
                                  </Box>
                                  <Box sx={{ flex: 1, px: 2 }}>
                                    {college?.city || "—"}
                                  </Box>
                                  <Box sx={{ flex: 1, px: 2 }}>
                                    {college?.state || "—"}
                                  </Box>
                                  <Box sx={{ flex: 1, px: 2 }}>
                                    {college?.ranking || "—"}
                                  </Box>
                                </Box>
                              );
                            }}
                          </List>
                        )}
                      </AutoSizer>
                    </Box>
                  </TableContainer>
                </div>

                {/* Jobs Section */}
                <div className="college">
                  <div className="collegeInner">
                    <div className="collegeDesc">
                      <h2>Jobs</h2>
                    </div>

                    <div className="collegeDesc">
                      <input
                        type="text"
                        placeholder="Search by title"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                      />
                    </div>
                  </div>

                  <TableContainer
                    sx={{ height: 400, borderRadius: 2, overflow: "hidden" }}
                  >
                    <Table
                      stickyHeader
                      aria-label="sticky table"
                      sx={{ tableLayout: "fixed" }}
                    >
                      <TableHead>
                        <TableRow>
                          {columnsJob.map((column) => (
                            <TableCell
                              key={column.id}
                              align={column.align}
                              style={{ minWidth: column.minWidth }}
                            >
                              {column.label}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>

                      {/* <TableBody>
          {filteredJobsHistory?.map((job, index) => (
            <TableRow hover role="checkbox" tabIndex={-1} key={job._id || index}>
              <TableCell align="left">{job?.title}</TableCell>
              <TableCell align="left">
                {job?.experienceStart} - {job?.experienceEnd} years
              </TableCell>
              <TableCell align="left">{job?.location}</TableCell>
              <TableCell align="left">{job?.numPosition}</TableCell>
              <TableCell align="left">{job?.applicant?.length}</TableCell>
            </TableRow>
          ))}
        </TableBody> */}
                    </Table>

                    <Box sx={{ height: 450, overflow: "auto" }}>
                      <AutoSizer>
                        {({ height, width }) => (
                          <List
                            height={height}
                            itemCount={filteredJobsHistory?.length || 0}
                            itemSize={150}
                            width={width}
                            overscanCount={5}
                          >
                            {({ index, style }) => {
                              const job = filteredJobsHistory?.[index];
                              if (!job) return null;

                              return (
                                <Box
                                  key={job._id || index}
                                  style={{
                                    ...style,
                                    display: "flex",
                                    borderBottom: "1px solid #e0e0e0",
                                    backgroundColor:
                                      index % 2 === 0 ? "#fafafa" : "#fff",
                                    alignItems: "center",
                                  }}
                                >
                                  <Box sx={{ flex: 1, px: 2 }}>
                                    {job?.title || "—"}
                                  </Box>
                                  <Box sx={{ flex: 1, px: 2 }}>
                                    {`${job?.experienceStart} - ${job?.experienceEnd} years` ||
                                      "—"}
                                  </Box>
                                  <Box sx={{ flex: 1, px: 2 }}>
                                    {job?.location || "—"}
                                  </Box>
                                  <Box sx={{ flex: 1, px: 2 }}>
                                    {job?.numPosition || "—"}
                                  </Box>
                                  <Box sx={{ flex: 1, px: 2 }}>
                                    {job?.applicant?.length || "—"}
                                  </Box>
                                </Box>
                              );
                            }}
                          </List>
                        )}
                      </AutoSizer>
                    </Box>
                  </TableContainer>
                </div>
              </div>

              <div className="collegeAddSec">
                <div className="college">
                  <div className="collegeInner">
                    <div className="collegeDesc">
                      <h2>Call history</h2>
                    </div>
                    <div className="collegeDesc">
                      <input
                        type="text"
                        placeholder="Search by Room Id"
                        value={searchRoomId}
                        onChange={(e) => setSearchRoomId(e.target.value)}
                      />
                    </div>
                  </div>
                  <TableContainer
                    sx={{ height: 400, borderRadius: 2, overflow: "hidden" }}
                  >
                    <Table
                      stickyHeader
                      aria-label="sticky table"
                      sx={{ tableLayout: "fixed" }}
                    >
                      <TableHead>
                        <TableRow>
                          {columnsCalls.map((column) => (
                            <TableCell
                              key={column.id}
                              align={column.align}
                              style={{ minWidth: column.minWidth }}
                            >
                              {column.label}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      {/* <TableBody>
  {filteredCallHistory
    ?.map((calls, index) => (
      <TableRow hover role="checkbox" tabIndex={-1} key={calls._id || index}>
        <TableCell align='left'>{calls?.user?.firstName} {calls?.user?.lastName}</TableCell>
        <TableCell align='left'>{calls?.counsellor?.name}</TableCell>
        <TableCell align="left">{calls?.duration}</TableCell>
        <TableCell align="left">{calls?.roomId}</TableCell>
        <TableCell align="left"  style={{
    color:
      calls?.status === "ended"
        ? "red"
        : calls?.status === "booked"
        ? "orange"
        : calls?.status === "accepted"
        ? "green"
        : "black", // default fallback
    fontWeight: "bold"
  }}>{calls?.status}</TableCell>
      </TableRow>
  ))}
</TableBody> */}
                    </Table>

                    <Box sx={{ height: 450, overflow: "auto" }}>
                      <AutoSizer>
                        {({ height, width }) => (
                          <List
                            height={height}
                            itemCount={filteredCallHistory?.length || 0}
                            itemSize={150}
                            width={width}
                            overscanCount={5}
                          >
                            {({ index, style }) => {
                              const calls = filteredCallHistory?.[index];
                              if (!calls) return null;

                              return (
                                <Box
                                  key={calls._id || index}
                                  style={{
                                    ...style,
                                    display: "flex",
                                    borderBottom: "1px solid #e0e0e0",
                                    backgroundColor:
                                      index % 2 === 0 ? "#fafafa" : "#fff",
                                    alignItems: "center",
                                  }}
                                >
                                  <Box sx={{ flex: 1, px: 2 }}>
                                    {`${calls?.user?.firstName} ${calls?.user?.lastName}` ||
                                      "—"}
                                  </Box>
                                  <Box sx={{ flex: 1, px: 2 }}>
                                    {calls?.counsellor?.name || "—"}
                                  </Box>
                                  <Box sx={{ flex: 1, px: 2 }}>
                                    {calls?.duration || "—"}
                                  </Box>
                                  <Box sx={{ flex: 1, px: 2 }}>
                                    {calls?.roomId || "—"}
                                  </Box>
                                  <Box
                                    style={{
                                      color:
                                        calls?.status === "ended"
                                          ? "red"
                                          : calls?.status === "booked"
                                            ? "orange"
                                            : calls?.status === "accepted"
                                              ? "green"
                                              : "black", // default fallback
                                      fontWeight: "bold",
                                    }}
                                    sx={{ flex: 1, px: 2 }}
                                  >
                                    {calls?.status || "—"}
                                  </Box>
                                </Box>
                              );
                            }}
                          </List>
                        )}
                      </AutoSizer>
                    </Box>
                  </TableContainer>
                </div>
                <div className="college">
                  <div className="collegeInner">
                    <div className="collegeDesc">
                      <h2>Session history</h2>
                    </div>
                    <div className="collegeDesc">
                      <input
                        type="text"
                        placeholder="Search by slot"
                        value={slot}
                        onChange={(e) => setSlot(e.target.value)}
                      />
                    </div>
                  </div>
                  <TableContainer
                    sx={{ height: 400, borderRadius: 2, overflow: "hidden" }}
                  >
                    <Table
                      stickyHeader
                      aria-label="sticky table"
                      sx={{ tableLayout: "fixed" }}
                    >
                      <TableHead>
                        <TableRow>
                          {columnsVideos.map((column) => (
                            <TableCell
                              key={column.id}
                              align={column.align}
                              style={{ minWidth: column.minWidth }}
                            >
                              {column.label}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {/* {filteredSessionHistory
    ?.map((calls, index) => (
      <TableRow hover role="checkbox" tabIndex={-1} key={calls._id || index}>
        <TableCell align='left'>{calls?.user?.firstName} {calls?.user?.lastName}</TableCell>
        <TableCell align='left'>{calls?.counsellor?.name}</TableCell>
        <TableCell align="left">{calls?.time}</TableCell>
        <TableCell align="left">{moment(calls?.startTime).format('DD MMM YYYY')}</TableCell>
        <TableCell align="left" style={{
    color: calls?.status === "Completed" ? "green" : "red",
    fontWeight: "bold"
  }}>{calls?.status}</TableCell>
      </TableRow>
  ))} */}
                      </TableBody>
                    </Table>

                    <Box sx={{ height: 450, overflow: "auto" }}>
                      <AutoSizer>
                        {({ height, width }) => (
                          <List
                            height={height}
                            itemCount={filteredSessionHistory?.length || 0}
                            itemSize={150}
                            width={width}
                            overscanCount={5}
                          >
                            {({ index, style }) => {
                              const calls = filteredSessionHistory?.[index];
                              if (!calls) return null;

                              return (
                                <Box
                                  key={calls._id || index}
                                  style={{
                                    ...style,
                                    display: "flex",
                                    borderBottom: "1px solid #e0e0e0",
                                    backgroundColor:
                                      index % 2 === 0 ? "#fafafa" : "#fff",
                                    alignItems: "center",
                                  }}
                                >
                                  <Box sx={{ flex: 1, px: 2 }}>
                                    {`${calls?.user?.firstName} ${calls?.user?.lastName}` ||
                                      "—"}
                                  </Box>
                                  <Box sx={{ flex: 1, px: 2 }}>
                                    {calls?.counsellor?.name || "—"}
                                  </Box>
                                  <Box sx={{ flex: 1, px: 2 }}>
                                    {calls?.time || "—"}
                                  </Box>
                                  <Box sx={{ flex: 1, px: 2 }}>
                                    {moment(calls?.startTime).format(
                                      "DD MMM YYYY",
                                    ) || "—"}
                                  </Box>
                                  <Box
                                    style={{
                                      color:
                                        calls?.status === "Completed"
                                          ? "green"
                                          : "red",
                                      fontWeight: "bold",
                                    }}
                                    sx={{ flex: 1, px: 2 }}
                                  >
                                    {calls?.status || "—"}
                                  </Box>
                                </Box>
                              );
                            }}
                          </List>
                        )}
                      </AutoSizer>
                    </Box>
                  </TableContainer>
                </div>
              </div>

              <div className="collegeAddSec">
                <div className="college">
                  <div className="collegeInner">
                    <div className="collegeDesc">
                      <h2>Payments request</h2>
                    </div>
                    <div className="collegeDesc">
                      <input
                        type="text"
                        placeholder="Search by requestId"
                        value={request}
                        onChange={(e) => setRequest(e.target.value)}
                      />
                    </div>
                  </div>
                  <TableContainer sx={{ maxHeight: 400 }}>
                    <Table stickyHeader aria-label="sticky table">
                      <TableHead>
                        <TableRow>
                          {columnsWithdraw.map((column) => (
                            <TableCell
                              key={column.id}
                              align={column.align}
                              style={{ minWidth: column.minWidth }}
                            >
                              {column.label}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {filteredWithdrawHistory?.map((calls, index) => (
                          <TableRow
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            key={calls._id || index}
                          >
                            <TableCell align="left">
                              {calls?.counsellor?.name}
                            </TableCell>
                            <TableCell align="left">{calls?.upiId}</TableCell>
                            <TableCell align="left">{calls?.inr}</TableCell>
                            <TableCell align="left">{calls?.reqId}</TableCell>
                            <TableCell align="left">
                              {calls?.status === "request" ? (
                                <button
                                  className="reqBtn"
                                  onClick={() => handleAccept(calls?._id)}
                                >
                                  Accept
                                </button>
                              ) : (
                                <button className="paidBtn" disabled>
                                  Paid
                                </button>
                              )}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
                <div className="college">
                  <div className="collegeInner">
                    <div className="collegeDesc">
                      <h2>Coin transaction</h2>
                    </div>
                    <div className="collegeDesc">
                      <input
                        type="text"
                        placeholder="Search by orderId"
                        value={oreder}
                        onChange={(e) => setOrder(e.target.value)}
                      />
                    </div>
                  </div>
                  <TableContainer sx={{ maxHeight: 400 }}>
                    <Table stickyHeader aria-label="sticky table">
                      <TableHead>
                        <TableRow>
                          {columnsPayment.map((column) => (
                            <TableCell
                              key={column.id}
                              align={column.align}
                              style={{ minWidth: column.minWidth }}
                            >
                              {column.label}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {filteredPaymentHistory?.map((calls, index) => (
                          <TableRow
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            key={calls._id || index}
                          >
                            <TableCell align="left">
                              {calls?.userId?.firstName}{" "}
                              {calls?.userId?.lastName}
                            </TableCell>
                            <TableCell align="left">{calls?.amount}</TableCell>
                            <TableCell align="left">{calls?.orderId}</TableCell>
                            <TableCell align="left">
                              {moment(calls?.createdAt).format("DD MMM YYYY")}
                            </TableCell>
                            <TableCell
                              align="left"
                              style={{
                                color:
                                  calls?.status === "paid" ? "green" : "red",
                                fontWeight: "bold",
                              }}
                            >
                              {calls?.status}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
